import React from 'react';
import { Checkbox } from 'antd';
import { PredictionScoreReportCardIcon } from '@/svgs';
import { useAuthContext } from '../../context/AuthContext';
import { bindEvents } from '@/utils/sensors';
import { useCommonInfoContext } from '../../context/CommonInfoProvider';

const userReportOptions = [
    { label: '一', value: '0' },
    { label: '二', value: '1' },
    { label: '三', value: '2' },
    { label: '四', value: '3' },
    { label: '五', value: '4' },
    { label: '六', value: '5' },
    { label: '日', value: '6' },
];

interface UserReportCardProps {
    userReportCalendar?: { userReportUrl: string; userReportDay: string[] };
}

const UserReportCard: React.FC<UserReportCardProps> = ({ userReportCalendar }) => {
    const { authUtils } = useAuthContext();
    const {
        commonInfo: { projectId, subjectId },
    } = useCommonInfoContext();

    const handleGotoUserReport = authUtils.withLoginCheck(() => {
        const userReportUrl = userReportCalendar?.userReportUrl;
        if (!userReportUrl) return;

        const url = new URL(userReportUrl);
        const params = new URLSearchParams(url.search);

        // 添加 isPc 参数
        params.set('isPc', '1');

        // 判断路由条件，设置 from 参数
        const href = location.href;
        if (href.includes('ep3')) {
            params.set('from', '6');
        } else if (href.includes('tiku.gaodun.com')) {
            params.set('from', '4');
        }

        url.search = params.toString();

        window.open(url.toString(), '_blank');
        bindEvents('Click_UserReport', {
            name: '点击用户报告',
            project_id: projectId,
            subject_id: subjectId,
        });
    });

    return (
        <div className="sub-tiku__predict-score-card sub-tiku__predict-score-card--user-report" onClick={handleGotoUserReport}>
            <div className="sub-tiku__predict-score-card-title">用户报告</div>
            <div className="sub-tiku__predict-score-card-content">
                <Checkbox.Group options={userReportOptions} value={userReportCalendar?.userReportDay} onChange={undefined} />
            </div>
            <PredictionScoreReportCardIcon />
        </div>
    );
};

export default UserReportCard;
